// Angular imports
import { OnDestroy, OnInit, ViewChild } from '@angular/core';

// Rxjs imports
import { Subscription } from 'rxjs';

// Component imports
import { DashboardViewerComponent } from '../dashboard-module/dashboard-viewer/dashboard-viewer.component';

// Service imports
import { CiraHelpService } from '../_services/shared-services/cira-help.service';
import { ContextManagerService } from '../_services/data-services/context-manager.service';
import { NavigationService } from '../_services/shared-services/navigation.service';
import { DynamicDashboardService } from '../dashboard-module/_services/dynamic-dashboard.service';

// Model imports
import { SideNavTreeInfo } from '../_models/side-nav-tree-info';
import { PropertyCommunityInfoResultDto } from '../_models/property-community-info-result-dto';
import { DynamicDashboardEntry } from '../dashboard-module/_model/dynamic-dashboard-entry';

export abstract class MPBaseWorkspaceManagerComponent implements OnInit, OnDestroy {
    @ViewChild('dashboardViewer', { static: false }) dashboardViewer: DashboardViewerComponent;

    helpLink: string;
    selectedContext: PropertyCommunityInfoResultDto;
    refreshedSubscription: Subscription;
    selectedSubscription: Subscription;
    navigationSubscription: Subscription;

    constructor(
        protected readonly helpKey: string,
        protected readonly ciraHelpService: CiraHelpService,
        protected readonly contextService: ContextManagerService,
        protected readonly navigationService: NavigationService,
        protected readonly dashboardService: DynamicDashboardService
    ) {
        this.selectedContext = this.contextService.getSelectedContext();
        this.helpLink = this.ciraHelpService.getHelpLinkByKey(
            helpKey,
            (this.selectedContext || { communityId: null }).communityId
        );
    }

    ngOnInit(): void {
        this.updateWorkspaceMenus(true);
        this.refreshedSubscription = this.dashboardService.refreshed.subscribe(this.updateWorkspaceMenus.bind(this));
        this.selectedSubscription = this.dashboardService.selectionChanged.subscribe((r: DynamicDashboardEntry) => {
            const parentId = this.getParentNodeId();
            this.navigationService.updateWorkspaceView({
                id: `${parentId}_${r.id}`,
                parentId,
                name: this.getAccessCode(),
                path: null,
                icon: '',
                text: r.name,
                tooltip: r.name,
                items: [],
                isWorkspace: true
            });
        });

        this.navigationSubscription = this.navigationService
            .onWorkspaceSelection()
            .subscribe((item: SideNavTreeInfo) => {
                this.dashboardViewer.onViewByName(item.text);
            });
    }

    ngOnDestroy(): void {
        if (!!this.refreshedSubscription) {
            this.refreshedSubscription.unsubscribe();
        }
        if (!!this.selectedSubscription) {
            this.selectedSubscription.unsubscribe();
        }
        if (!!this.navigationSubscription) {
            this.navigationSubscription.unsubscribe();
        }
    }

    protected abstract getParentNodeId(): string;

    protected abstract getAccessCode(): string;

    private updateWorkspaceMenus(reload: boolean): void {
        if (reload) {
            this.dashboardService.getDashboards().subscribe((results: DynamicDashboardEntry[]) => {
                const parentId = this.getParentNodeId();
                const items = results.map((r) => {
                    return {
                        id: `${parentId}_${r.id}`,
                        parentId,
                        name: this.getAccessCode(),
                        path: null,
                        icon: '',
                        text: r.name,
                        tooltip: r.name,
                        items: [],
                        isWorkspace: true
                    } as SideNavTreeInfo;
                });
                this.navigationService.updateWorkspaceMenus({ parentId, items });
            });
        }
    }
}
